// download html as image

import { useCallback } from 'react'
import html2canvas, { Options } from 'html2canvas'
import { checkInWebview, downloadImageToDevice } from './useWebViewHandler'

const iOSIsInstalled = window.navigator.standalone === true
function dataUrlToFile(dataUrl, name) {
  const [head, b64] = dataUrl.split(',')
  const mime = head.match(/:(.*?);/)[1]
  const bin = atob(b64)
  const bytes = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
  return new File([bytes], name, { type: mime })
}

export const useHtml2Image = () => {
  const downloadHtmlAsImage = useCallback(
    async (htmlElement: HTMLElement | null | undefined, imageName: string, options?: Partial<Options>) => {
      if (!htmlElement) return

      const canvas = await html2canvas(htmlElement, {
        //   scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: null,
        ...options,
      })
      const src = canvas.toDataURL('image/png', 1.0)
      if (checkInWebview()) {
        // 呼叫webview下載handler
        await downloadImageToDevice(src, `${imageName}.png`)
        return
      } else {
        const file = dataUrlToFile(src, `${imageName}.png`) // sync, so the tap still counts
        if (iOSIsInstalled && navigator.canShare?.({ files: [file] })) {
          navigator.share({ files: [file] }).catch(() => {})
        } else {
          const url = URL.createObjectURL(file)
          const link = document.createElement('a')
          document.body.appendChild(link)
          link.style.display = 'none'
          link.href = url
          link.download = `${imageName}.png`
          link.click()
          document.body.removeChild(link)
        }
      }
    },
    []
  )

  return { downloadHtmlAsImage }
}
